export const labels = {
  //Validation
  missingReferenceSheet:
    "Could not find worksheet 'Reference_sheet'. To try again, open EY Canvas Bulk Update Add-in in a new workbook.",
  descriptionError: "Description exceeds {0} character limit",
  titleMissingError: "Missing Title (required)",
  titlemaxLimitError: "Title exceeds {0} character limit",
  userNotFromSelectedGroup:
    "Request cannot be assigned to both a group and user",
  dueDateFormatError: "Invalid date format in Due date",
  fieldError:
    "Could not update EY Canvas, as some records had errors. Check the Status column for details.",
  invalidColumn: "Invalid data in {0}",
  requiredColumn: "{0} is required",
  hashValueMissing:
    "Hash value needed to update EY Canvas. Check column in this worksheet.",
  // Panel Headers
  engagement: "Engagement",
  select: "Select",
  numberOfRecords: "Number of records",
  dowanloadedOn: "Downloaded on",
  canvasUpdatesOn: "Sent to EY Canvas for processing",
  selectRecordsToUpdate: "Select records to update",
  atlasWorkpaperIndexFramework: "EY Atlas: Workpaper indexing framework",
  referenceOnly: "Reference only",
  columnsToUpdate: "Update these columns",
  dueDateRequired: "Due date required",
  requestNotAssignedError: "Assign the request to a group or user",
  infoText:
    "You cannot run EY Canvas Bulk Update Add-in on multiple sheets in the same workbook. To edit a new item or EY Canvas engagement, open this tool in a new workbook.",
  noUpdatesSaved: "No updates saved",
  dummyLocalizationText: "Dummy Localization Text",
  unexpectedApiFailure: "Unexpected API failure. Please try again.",
  titleLengthExceeded: "Title exceeds 500 character limit",
  DescriptionLengthExceeded: "Description exceeds 4000 character limit",
  canvasDataEditor: "Canvas data editor",
  selectanitemtoedit: "Select an option",
  editRequestMessage: "Which requests would you like to edit?",
  selectRequestStatus: "Select at least one request status",
  selectRequestErrorMessage: "Select at least one request status",
  sheetWithSameNameExist:
    "A sheet named Input_sheet_{0} already exists. Please rename the sheet to continue.",
  engagementIdNotFound:
    "Could not find the EY Canvas engagement. Check the Engagement ID and confirm you have access to open the EY Canvas engagement.",
  boundSheetAlreadyExist_1: "EY Canvas Bulk Update Add-in",
  boundSheetAlreadyExist_2: "does not work on this tab",
  selectAnOperation: "What would you like to do?",
  submit: "Submit",
  next: "Next",
  eyCanvasEngagement: "Select an engagement",
  search: "Search",
  engagementNotSelected: "Select an engagement",
  invalidEngagement: "Select a valid engagement",
  back: "Back",
  noRecordsFound: "No records found",
  masterSheetNoteText:
    "Note: This sheet is required to use EY Canvas Bulk Update Add-in.",
  informationText: "This tool allows you to:",
  infoText1:
    "Edit EY Canvas document and task names for Standardized Indexing, and",
  infoText3: "Create and edit other items in EY Canvas",
  infoTextforonlyAddClientRequest: "Create client requests",
  yes: "Yes",
  no: "No",
  close: "Close",
  ownedByEngagement: "Owned by this engagement",
  sharedToEngagement: "Shared into this engagement",
  status: "Status",
  statusId: "Status ID",
  Continue: "Continue",
  updateCanvas: "Update EY Canvas",
  newDocumentName: "New document name",
  documentName: "Document name",
  fileExt: "File extension",
  shared: "Shared",
  docId: "Document ID",
  hash: "Hash",
  newPrefix: "New prefix",
  newSuffix: "New suffix",
  newTitle: "New title",
  taskPrefix: "Task prefix",
  taskSuffix: "Task suffix",
  taskTitle: "Title",
  taskType: "Task type",
  taskTitleEditable: "Task title editable",
  auditPhase: "Audit phase",
  milestone: "Milestone",
  timePhase: "Time phase",
  taskId: "Task ID",
  populateMsg: "Populating records from EY Canvas",
  updatingCanvas: "Updating EY Canvas. <br /> This may take a few minutes.",
  loadingContent: "Loading content",
  filenameRequired: "File name is required",
  excelError: "Excel formula error. Fix and try again.",
  specialCharacters: "Document name cannot contain */:<>\\?|" + '"',
  sameDocumentNameError: "New and old document names are the same",
  docNameLimit: "Document name cannot exceed 115 characters",
  markValueInvalid: "Invalid value in 'Update EY Canvas'. Fix and try again.",
  docAndHashNull:
    "Document ID and/or Hash value needed to update EY Canvas. Check those columns in this worksheet.",
  help: "Help",
  entityNotSelected: "Select an option to continue",
  AssignedToGroupInputMessageTitle: "Select a group (optional)",
  AssignedToGroupInputMessageDescription:
    "To assign to a whole group, select a group and leave the next column empty.",
  AssignedToUserInputMessageTitle: "Select a user (optional)",
  AssignedToUserInputMessageDescription:
    "To assign to a specific user, select a user and leave the previous column empty. Users are listed by group.\n\nNote: All group members will be able to view the request.  If a user is in multiple groups, check you are selecting the correct dropdown option.",
  apiServerExceptionError:
    "An error occurred connecting to EY Canvas. Please try again. If the issue persists, contact the Help Desk",
  taskNameExceedsLimit:
    "Exceeds character limit (title: 500 characters; prefix/suffix: 50 characters)",
  taskTypeUpdateNotAllowed: "Task title cannot be edited for this task type",
  taskEmptyHashOrDocId:
    "Task ID and/or Hash value needed to update EY Canvas. Check those columns in this worksheet.",
  taskTitleRequiredError: "Task title is required",
  sameTaskNameError:
    "New and old task name (prefix, suffix, title) are the same",
  universalUserPreferenceGetError:
    "User preference error occurred connecting to EY Canvas. Please try again. If the issue persists, contact the Help Desk",
  sameWorkbookMultipleSessionsError:
    "You cannot run multiple editing sessions within the same workbook. To edit a new item or EY Canvas engagement, open this tool in a new workbook.",
  errorMessageOnExcelUpdate:
    "Could not update EY Canvas, as some records had errors. Check the<b> Status </b>column for details.",
  insufficientPermissionsError:
    "Insufficient permissions. Check that you can open the EY Canvas engagement and try again.",
  ApiValidationErrorPreConditionFailedDocument:
    "Could not update EY Canvas. Some documents may have been moved or deleted. Reload the data in a new workbook and try again.",
  ApiValidationFailedWithErrorDocument:
    "Could not update EY Canvas, as some documents had errors. Check the Status column for details.",
  apiServerConnectError:
    "Could not connect to EY Canvas. You may need to be on the EY network to edit this engagement. If the issue persists, contact the Help Desk.",
  apiServerError:
    "An error occurred connecting to EY Canvas. Please try again. If the issue persists, contact the Help Desk.",
  duplicateDocumentNameError: "Duplicate document name",
  APIValidationError:
    "Some records could not be updated in EY Canvas. Check the<b> Status </b>column for details.",
  excelPopulatingMessage:
    "Populating Excel. This may take a few minutes. Do not click on the Excel worksheets until the data has finished loading.",
  generalError:
    "An error occurred. Please reload EY Canvas Bulk Update Add-in and try again.",
  boundSheetAlreadyPopulated:
    "Another EY Canvas Bulk Update Add-in session was already started in this workbook. Try again in a new workbook.",
  excelRenderIssue:
    "Data loading from EY Canvas was interrupted when you clicked on an Excel worksheet. To try again, start an EY Canvas Excel Add-in session in a new workbook.",
  offlineModeLoadingMessage:
    "Opening the EY Canvas Excel Add-in. This may take a few minutes. Do not click on the Excel worksheets until the data has finished loading.",
  offlineModeUserClickError:
    "Opening the EY Canvas Bulk Update Add-in was interrupted when you clicked on an Excel worksheet. To try again, close and re-open the EY Canvas Bulk Update Add-in.",
  inActiveWorkbookError:
    "An error occurred with EY Canvas Bulk Update Add-in. Please open a new workbook and try again. To prevent this error in the future, avoid switching workbooks while data is populating.",
  clientRequestTitleMissing: "Missing Title (required)",
  addclinetRequestTagError:
    "Request created in EY Canvas but tags could not be added. You can manually add the tags in EY Canvas.",
  editclinetRequestTagError:
    "Tags could not be edited for this request. You can manually add or remove tags in EY Canvas.",
  clinetRequestEYContactError:
    "EY contacts could not be edited for this request. You can manually add or remove EY contacts in EY Canvas.",
  forbiddenByEYError:
    "The action taken was forbidden by EY Information Security. Refresh the page and try again. If the issue persists contact the Help Desk.",
  genericErrorMessage:
    "An error occurred with EY Canvas Bulk Update Add-in. Please open a new workbook and try again.",
  itgcName: "ITGC name (required)",
  misstatementIndex: "Misstatement index (required)",
  misstatementDescription: "Misstatement description (required)",
  misstatementId: "Misstatement ID",
  controlName: "Control name (required)",
  frequency: "Frequency",
  designEffectiveness: "Design effectiveness",
  controlType: "Control type",
  controlId: "Control ID",
  operatingEffectiveness: "Operating effectiveness",
  testing: "Testing",
  itControlId: "IT Control ID",
  isControlLowerRisk: "Is control lower risk?",
  timePhaseName: "Time phase name (required)",
  milestoneRequired: "Milestone (required)",
  startDate: "Start date (YYYY-MM-DD) (required)",
  endDate: "End date (YYYY-MM-DD) (required)",
  keyEvent: "Key event",
  timePhaseId: "Time phase ID",
  startDateFormatError: "Invalid date format in Start date",
  endDateFormatError: "Invalid date format in End date",
  deficiencyTitle: "Deficiency title (required)",
  deficiencyDescription: "Deficiency description (required)",
  deficiencyTitleOriginal: "Deficiency title",
  deficiencyDescriptionOriginal: "Deficiency description",
  deficiencyCategory: "Category",
  deficiencyId: "Deficiency ID",
  deficiencyTitleMaxLimitError: "Deficiency title exceeds 100 character limit",
  deficiencyTitleRequiredError: "Deficiency title is required",
  deficiencyDescriptionMaxLimitError:
    "Deficiency description exceeds 4000 character limit",
  deficiencyDescriptionRequiredError: "Deficiency description is required",
  invalidDeficiencyId: "Invalid Deficiency ID",
  prefix: "Prefix",
  suffix: "Suffix",
  requiredTitle: "Title (required)",
  timePhaseRequired: "Time phase (required)",
  taskGroupRequired: "Task group (required)",
  taskGroups: "Task group",
  customizedDescription: "Customized description",
  customizedDescriptionRequired: "Customized description (required)",
  picSignOffRequired: "PIC sign-off",
  eqrSignOffRequired: "EQR sign-off",
  invalidDataInTags: "Invalid data in Tags",
  taskTags: "Tags",
  editTaskAPIError:
    "Tags could not be edited for this task. You can manually add or remove tags in EY Canvas.",
  engagementLDCVersionUpdateError:
    "An update is available for EY Canvas Bulk Update Add-in. Open the add-in in a new workbook to save changes to task names.",
  module: "Module",
  titleForMultiSelectInputMessage: "Multi-select dropdown",
  descriptionForMultiSelectInputMessage:
    "Select one or more dropdown options using the add-in pane on the right.",
  errorBoundaryMessage:
    "An error has occurred. Please refresh the page and try again. If the issue persists, contact the Help Desk.",
};

// export const instructionSheet={
//  headers:['#','Field Name', 'Additional instructions','To upload as Draft', 'To send to client']

//  }

export const instructionSheetHeader = {
  // reference sheet columns
  count: "#",
  fieldName: "Field name",
  additionalInstructions: "Additional instructions",
  toUploadAsDraft: "To upload as Draft",
  toSaveAsDraft: "To save as Draft",
  toSendToClient: "To send to client",
  bulkUpdateAddIn: "EY Canvas Bulk Update Add-in",
  purpose: "Purpose",
  guidance: "Guidance",
  overView: "Overview of fields",
  required: "Required",
};

export const instructionSheetDataForEditClient = {
  purpose:
    "This tool can be used to bulk edit client requests in EY Canvas Collaboration.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on how to use EY Canvas Collaboration, including how to bulk edit and send requests from EY Canvas Collaboration.",
  additionalInfo:
    "\u00B9 This is multi-select dropdown field. To edit this field, use the dropdown on the add-in pane on the right.",
  bulkUpdate: "\u00B2 See Additional instructions",
};
export const instructionSheetDataForAddTaskOST = {
  purpose:
    "This tool can be used to bulk upload new tasks (OSTs) to EY Canvas.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on Task assignments in EY Canvas, including how to bulk assign tasks in EY Canvas.",
  additionalInfo:
    "\u00B9 This is a multi-select dropdown field. To edit this field, use the dropdown in the add-in pane on the right.",
};
export const instructionSheetDataForEditTasks = {
  purpose: "This tool can be used to bulk edit tasks in EY Canvas.",
  guidanceHyperlinkforStandardizedIndexing: "Standardized Indexing",
  guidanceforStandardizedIndexing:
    "This tool can be used to facilitate Standardized Indexing for tasks. Refer to the EY Atlas guidance link for details on Standardized Indexing.",
  guidanceHyperlinkForTaskAssignments: "Task assignments",
  guidanceForTaskAssignments:
    "Refer to the EY Atlas link for additional guidance on Task assignments in EY Canvas, including how to bulk assign tasks in EY Canvas.",
  additionalInfo:
    "\u00B9 This is a multi-select dropdown field. To edit this field, use the dropdown in the add-in pane on the right.",
};
export const instructionSheetTabularDataForEditTasks = [
  {
    count: "1",
    fieldName: "Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas",
    required: "Yes",
  },
  {
    count: "2",
    fieldName: "Prefix",
    additionalInstructions:
      "Use a prefix to support a naming convention for Standardized Indexing (50 character limit)",
    required: "No",
  },
  {
    count: "3",
    fieldName: "Title",
    additionalInstructions:
      "Develop a naming convention that will help you efficiently manage your tasks (500 character limit)",
    required: "Yes",
  },
  {
    count: "4",
    fieldName: "Suffix",
    additionalInstructions: "50 character limit",
    required: "No",
  },
  {
    count: "5",
    fieldName: "Time phase",
    additionalInstructions:
      "Assign tasks to time phases to support effective project management",
    required: "Yes",
  },
  {
    count: "6",
    fieldName: "Task group",
    additionalInstructions:
      "Organize audit work into manageable groups of tasks. Task groups can only be edited for OSTs.",
    required: "Yes",
  },
  {
    count: "7",
    fieldName: "Customized description",
    additionalInstructions:
      "Describe the procedures to be performed for this task",
    required: "No",
  },
  {
    count: "8",
    fieldName: "Tags \u00B9",
    additionalInstructions:
      "Tags are custom labels available in EY Canvas that can assist in managing tasks",
    required: "No",
  },
  {
    count: "9",
    fieldName: "PIC sign-off",
    additionalInstructions:
      "Indicate whether the task requires PIC sign-off. (Cannot be edited if PIC sign-off is designated from Knowledge.)",
    required: "No",
  },
  {
    count: "10",
    fieldName: "EQR sign-off",
    additionalInstructions:
      "Indicate whether the task requires EQR sign-off. (Cannot be edited if EQR sign-off is designated from Knowledge.)",
    required: "No",
  },
];

export const instructionSheetTabularDataForEditClient = [
  {
    count: "1",
    fieldName: "Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the request in the list sent to EY Canvas \r\n - 'No' will exclude the request from the list sent to EY Canvas",
    toSaveAsDraft: "Yes",
    toSendToClient: "N/A",
  },
  {
    count: "2",
    fieldName: "Title",
    additionalInstructions:
      "Develop a naming convention that will help you efficiently manage all Requests.",
    toSaveAsDraft: "Yes",
    toSendToClient: "Yes",
  },
  {
    count: "3",
    fieldName: "Description",
    additionalInstructions: "The Description has a 4,000 character limit",
    toSaveAsDraft: "No",
    toSendToClient: "No",
  },
  {
    count: "4",
    fieldName: "Assigned to (group)",
    additionalInstructions:
      "Assign the Request to an external user or group.\r\n - To assign to a group, select from Assigned to (group) and leave the next column empty.\r\n - To assign to a specific user, select a user and leave the previous column empty. Users are listed by group.\r\n \r\nNote: All group members will be able to view the request. If a user is in multiple groups, check you are selecting the correct drop-down option.",
    toSaveAsDraft: "No",
    toSendToClient: "One of these is required",
  },
  {
    count: "5",
    fieldName: "Assigned to (user)",
    additionalInstructions: "",
    toSaveAsDraft: "No",
    toSendToClient: "",
  },
  {
    count: "6",
    fieldName: "Due date (YYYY-MM-DD)",
    additionalInstructions:
      "Due date must be specified in YYYY-MM-DD format. If a Due date is not specified but a Time phase is selected, the Due date will default to the end date of the Time phase.",
    toSaveAsDraft: "No",
    toSendToClient: "Yes \u00B2",
  },
  {
    count: "7",
    fieldName: "EY contact \u00B9",
    additionalInstructions:
      "Add an EY contact to let the external user know who to contact if they have questions. The EY contact will receive a notification when the client responds to the request.",
    toSaveAsDraft: "No",
    toSendToClient: "No",
  },
  {
    count: "8",
    fieldName: "Tags \u00B9",
    additionalInstructions:
      "Tags are custom labels available in Collaboration to assist in managing the requests. You can see tags applied by the team and those applied by external users. Tags will be synchronized between Collaboration and EY Canvas Client Portal automatically.",
    toSaveAsDraft: "No",
    toSendToClient: "No",
  },
  {
    count: "9",
    fieldName: "Priority",
    additionalInstructions:
      "Set a Request priority of High or Critical to help your client prioritize the requests. If not specified, the Request priority will default to Normal.",
    toSaveAsDraft: "No",
    toSendToClient: "Yes \u00B2",
  },
  {
    count: "10",
    fieldName: "Time phase",
    additionalInstructions: "Select a Time phase and/or Due date (see above).",
    toSaveAsDraft: "No",
    toSendToClient: "No",
  },
];

export const instructionSheetData = {
  purpose:
    "This tool can be used to bulk upload new client requests to EY Canvas Collaboration. Requests will be uploaded in 'Draft' status. You can then bulk send requests to the client from EY Canvas Collaboration.",
  guidanceHyperlink: "EY Atlas",
  //  guidanceHyperlink:"<a 'href=https://live.atlas.ey.com/#document/1146470?pref=20052/9/1007&crumb=11'>EY Atlas</a>",
  guidance:
    "Refer to the EY Atlas link for additional guidance on how to use EY Canvas Collaboration, including how to bulk edit and send requests from EY Canvas Collaboration.",
  additionalInfo: "\u00B2 See Additional instructions",
  bulkUpdate:
    "\u00B9 This is a multi-select dropdown field. To edit this field, use the dropdown in the add-in pane on the right.",
};

export const instructionSheetTabularData = [
  {
    count: "1",
    fieldName: "Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the request in the list sent to EY Canvas \r\n - 'No' will exclude the request from the list sent to EY Canvas",
    toUploadAsDraft: "Yes",
    toSendToClient: "N/A",
  },
  {
    count: "2",
    fieldName: "Title (required)",
    additionalInstructions:
      "Develop a naming convention that will help you efficiently manage all Requests.",
    toUploadAsDraft: "Yes",
    toSendToClient: "Yes",
  },
  {
    count: "3",
    fieldName: "Description",
    additionalInstructions: "The Description has a 4,000 character limit",
    toUploadAsDraft: "No",
    toSendToClient: "No",
  },
  {
    count: "4",
    fieldName: "Assigned to (group)",
    additionalInstructions:
      "Assign the Request to an external user or group.\r\n - To assign to a group, select from Assigned to (group) and leave the next column empty.\r\n - To assign to a specific user, select a user and leave the previous column empty. Users are listed by group.\r\n \r\nNote: All group members will be able to view the request. If a user is in multiple groups, check you are selecting the correct drop-down option.",
    toUploadAsDraft: "No",
    toSendToClient: "One of these is required",
  },
  {
    count: "5",
    fieldName: "Assigned to (user)",
    additionalInstructions: "",
    toUploadAsDraft: "No",
    toSendToClient: "",
  },
  {
    count: "6",
    fieldName: "Due date (YYYY-MM-DD)",
    additionalInstructions:
      "Due date must be specified in YYYY-MM-DD format. If a Due date is not specified but a Time phase is selected, the Due date will default to the end date of the Time phase.",
    toUploadAsDraft: "No",
    toSendToClient: "Yes \u00B2",
  },
  {
    count: "7",
    fieldName: "EY contact \u00B9",
    additionalInstructions:
      "Add an EY contact to let the external user know who to contact if they have questions. The EY contact will receive a notification when the client responds to the Request.",
    toUploadAsDraft: "No",
    toSendToClient: "No",
  },
  {
    count: "8",
    fieldName: "Tags \u00B9",
    additionalInstructions:
      "Tags are custom labels available in Collaboration to assist in managing the requests. You can see tags applied by the team and those applied by external users. Tags will be synchronized between Collaboration and EY Canvas Client Portal automatically.",
    toUploadAsDraft: "No",
    toSendToClient: "No",
  },
  {
    count: "9",
    fieldName: "Priority",
    additionalInstructions:
      "Set a Request priority of High or Critical to help your client prioritize the requests. If not specified, the Request priority will default to Normal.",
    toUploadAsDraft: "No",
    toSendToClient: "Yes \u00B2",
  },
  {
    count: "10",
    fieldName: "Time phase",
    additionalInstructions: "Select a Time phase and/or Due date (see above).",
    toUploadAsDraft: "No",
    toSendToClient: "No",
  },
];

export const instructionSheetStaticDataITGC = {
  purpose: "This tool can be used to bulk edit ITGC details in EY Canvas.",
  additionalInfo:
    "\u002AIf a value is already specified in EY Canvas, it can be changed but not deleted.",
};
export const instructionSheetStaticDataMisstatement = {
  purpose:
    "This tool can be used to bulk edit misstatement details in EY Canvas.",
  additionalInfo:
    "\u002AIf a value is already specified in EY Canvas, it can be changed but not deleted.",
};
export const instructionSheetDataForMisstatements = {
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on misstatements and summary of audit differences.",
};
export const instructionSheetTabularDataMisstatement = [
  {
    count: "1",
    fieldName: "Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in:\r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas",
    required: "Yes",
  },
  {
    count: "2",
    fieldName: "Misstatement index",
    additionalInstructions: "Unique identifier for the misstatement (100 character limit)",
    required: "Yes",
  },
  {
    count: "3",
    fieldName: "Misstatement description",
    additionalInstructions:
      "Description of the misstatement (500 character limit)\n",
    required: "Yes",
  },
];
export const instructionSheetStaticDataAddTaskOST = {
  purpose:
    "This tool can be used to bulk upload new tasks (OSTs) to EY Canvas.",
  additionalInfo:
    "\u002AIf a value is already specified in EY Canvas, it can be changed but not deleted.",
};
export const instructionSheetTabularDataForAddTaskOST = [
  {
    count: "1",
    fieldName: "Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas",
    required: "Yes",
  },
  {
    count: "2",
    fieldName: "Prefix",
    additionalInstructions:
      "Use a prefix to support a naming convention for Standardized Indexing (50 character limit)",
    required: "No",
  },
  {
    count: "3",
    fieldName: "Title",
    additionalInstructions:
      "Develop a naming convention that will help you efficiently manage your tasks (500 character limit)",
    required: "Yes",
  },
  {
    count: "4",
    fieldName: "Suffix",
    additionalInstructions: "50 character limit",
    required: "No",
  },
  {
    count: "5",
    fieldName: "Time phase",
    additionalInstructions:
      "Assign tasks to time phases to support effective project management",
    required: "Yes",
  },
  {
    count: "6",
    fieldName: "Task group",
    additionalInstructions: "Organize work into manageable groups of tasks",
    required: "Yes",
  },
  {
    count: "7",
    fieldName: "Customized description",
    additionalInstructions:
      "Describe the procedures to be performed for this task",
    required: "Yes",
  },
  {
    count: "8",
    fieldName: "Tags \u00B9",
    additionalInstructions:
      "Tags are custom labels available in EY Canvas that can assist in managing tasks",
    required: "No",
  },
  {
    count: "9",
    fieldName: "PIC sign-off",
    additionalInstructions: "Indicate whether the task requires PIC sign-off",
    required: "No",
  },
  {
    count: "10",
    fieldName: "EQR sign-off",
    additionalInstructions: "Indicate whether the task requires EQR sign-off",
    required: "No",
  },
];
export const instructionSheetStaticDataControl = {
  purpose: "This tool can be used to bulk edit control details in EY Canvas.",
  additionalInfo:
    "\u002AIf a value is already specified in EY Canvas for this field, it can be changed but not deleted.",
};

export const instructionSheetStaticDataTimePhase = {
  purpose:
    "This tool can be used to bulk edit time phases details in EY Canvas.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on the Milestones Program, which promotes effective project management and timely audit pacing. Teams can associate time phases to each milestone to plan completion of audit work by scheduled deadlines and mitigate the potential for undue compression during the year-end reporting cycle.",
};

export const instructionSheetTabularDataTimePhase = [
  {
    count: "1",
    fieldName: "Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas",
    required: "Yes",
  },
  {
    count: "2",
    fieldName: "Time phase name",
    additionalInstructions: "500 character limit",
    required: "Yes",
  },
  {
    count: "3",
    fieldName: "Milestone",
    additionalInstructions: "Select a milestone from the drop-down list",
    required: "Yes",
  },
  {
    count: "4",
    fieldName: "Start date",
    additionalInstructions: "Must be specified in YYYY-MM-DD format",
    required: "Yes",
  },
  {
    count: "5",
    fieldName: "End date",
    additionalInstructions: "Must be specified in YYYY-MM-DD format",
    required: "Yes",
  },
  {
    count: "6",
    fieldName: "Key event",
    additionalInstructions:
      "Indicate if this milestone is a key event in the completion of audit work",
    required: "No",
  },
];

export const instructionSheetTabularDataITGC = [
  {
    count: "1",
    fieldName: "Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas",
    required: "Yes",
  },
  {
    count: "2",
    fieldName: "ITGC name (required)",
    additionalInstructions: "ITGC name has a 500 character limit",
    required: "Yes",
  },
  {
    count: "3",
    fieldName: "Frequency",
    additionalInstructions:
      "Select a control frequency from the drop-down list",
    required: "No\u002A",
  },
  {
    count: "4",
    fieldName: "Design effectiveness",
    additionalInstructions:
      "If design effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective)",
    required: "No",
  },
  {
    count: "5",
    fieldName: "Operating effectiveness",
    additionalInstructions:
      "If operating effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective)",
    required: "No",
  },
  {
    count: "6",
    fieldName: "Testing",
    additionalInstructions: "Indicate if we plan to test this control",
    required: "No",
  },
];

export const instructionSheetTabularDataControl = [
  {
    count: "1",
    fieldName: "Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas",
    required: "Yes",
  },
  {
    count: "2",
    fieldName: "Control name (required)",
    additionalInstructions: "Control name has a 500 character limit",
    required: "Yes",
  },
  {
    count: "3",
    fieldName: "Frequency",
    additionalInstructions:
      "Select a control frequency from the drop-down list",
    required: "No\u002A",
  },
  {
    count: "4",
    fieldName: "Control type",
    additionalInstructions: "Select a control type from the drop-down list",
    required: "No\u002A",
  },
  {
    count: "5",
    fieldName: "Design effectiveness",
    additionalInstructions:
      "If design effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective)",
    required: "No",
  },
  {
    count: "6",
    fieldName: "Operating effectiveness",
    additionalInstructions:
      "If operating effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective)",
    required: "No",
  },
  {
    count: "7",
    fieldName: "Testing",
    additionalInstructions: "Indicate if we plan to test this control",
    required: "No",
  },
  {
    count: "8",
    fieldName: "Is control lower risk?",
    additionalInstructions: "Indicate if the control is lower risk",
    required: "No",
  },
];

export const errors = {
  14057: "Duplicate document name",
  14084: "Document name cannot contain */:<>\\?|" + '"',
  14085: "Document name cannot exceed 115 characters",
  14086: "DocService failed while updating document details.",
  14088: "Duplicate document name",
  5166: "Task title cannot be edited for this task type",
  5170: "Exceeds character limit (title: 500 characters; prefix/suffix: 50 characters)",
  5169: "Exceeds character limit (title: 500 characters; prefix/suffix: 50 characters)",
  5047: "Exceeds character limit (title: 500 characters; prefix/suffix: 50 characters)",
  5018: "Task deleted or rejected in EY Canvas",
  14071: "File name is required",
  14054: "File name is required",
  409: "Duplicate document name",
  21071:
    "Count of client requests sent in the body exceeds the maximum allowed limit.",
  21041: "Title exceeds 500 character limit",
  21076: "Invalid data in Priority",
  21042: "Description exceeds 4000 character limit",
  21072: "Invalid data in Due date",
  21027: "Missing Title (required)",
  21039: "Assign the request to a valid group/user",
  21032: "Assign the request to a valid group/user",
  21034: "Client Group does not have active users",
  21035: "Request not found in EY Canvas",
  21036: "Invalid data in Time phase",
  21057:
    "EY Contact is not a member of the engagement, is not Active, or is Independence-only",
  21073:
    "One or more data in Request payload is not valid. Please verify the data and try again.",
  21074: "Cannot change Title, Description, or Priority for Received requests",
  21075:
    "Cannot change Title, Description, Assigned to (group), Assigned to (user), Due date, Priority or Timephase for Accepted requests",
  21076: "PriorityTypeId enum does not contain 1, 2 or 3",
  21077: "Specify a due date in YYYY-MM-DD format",
  21078:
    "Group and User are both required, when updating either Assigned To Group or Assigned To User",
  21079: "Specify a due date in YYYY-MM-DD format",
  21080: "Due date is required, when Timephase is available",
  21081: "EY Contact(s) is not valid or includes duplicates",
  25000: "Specify a time phase",
  26000: "Specify a due date in YYYY-MM-DD format",
  84006: "ITGC name is required",
  84007: "ITGC name exceeds 500 character limit",
  84008: "Invalid data in Frequency",
  84029: "Invalid data in Frequency",
  84010: "Invalid data in Design effectiveness",
  84027: "Invalid data in testing",
  84028: "Invalid data in testing",
  84031: "Cannot conclude on Operating Effectiveness if Testing = No",
  84032: "Invalid data in Design effectiveness",
  84004: "Invalid IT Control ID",
  37007: "Misstatement index is required",
  37009: "Misstatement description is required",
  37130: "Misstatement description exceeds 500 character limit",
  37036: "Invalid Misstatement ID",
  37072: "Misstatement index exceeds 100 character limit",
  83018: "Control name exceeds 500 character limit",
  83004: "Invalid Control ID",
  83006: "Control name is required",
  83009: "Invalid data in Frequency",
  83010: "Invalid data in Control type",
  83031: "Invalid data in IsIPEManuallyTested",
  83012: "Invalid data in Design effectiveness",
  83033: "Invalid data in Operating effectiveness",
  83034: "Invalid data in testing",
  85004: "Invalid Deficiency ID",
  85006: "Deficiency title is required",
  85018: "Deficiency title exceeds 100 character limit",
  85019: "Deficiency description is required",
  85042: "Deficiency description exceeds 4000 character limit",
  5169: "Prefix exceeds 50 character limit",
  5170: "Suffix exceeds 50 character limit",
  5047: "Title exceeds 500 character limit",
  5108: "Description exceeds 4000 character limit",
  5059: "Invalid data in Time phase (required)",
  5111: "Invalid data in Task group (required)",
  5051: "Invalid data in Task group (required)",
  5019: "Customized description (required) is required",
  5103: "Title (required) is required",
  5104: "Time phase (required) is required",
  5109: "Task group (required) is required",
  5203: "PIC sign-off is required",
  5204: "EQR sign-off is required",
  5202: "Cannot change task group",
  5168: "Title (required) is required",
  16003: "Invalid Time phase ID",
  16006: "Invalid data in Time phase name (required)",
  16007: "Invalid data in Milestone",
  16008: "Invalid data in Start date",
  16009: "Invalid data in End date",
  16010: "Time phase name (required) is required",
  16022: "Specify a date later than 1900-01-01",
  16023: "End date must be on or after the Start date",
  16024: "Key event is required",
  16025: "Start date must be on or before the End date",
  16026: "Time phase deleted or not found in EY Canvas",
  16027: "Time phase name exceeds 500 character limit",
  16028: "Milestone (required) is required",
  16029: "Start date (YYYY-MM-DD) (required) is required",
  16030: "End date (YYYY-MM-DD) (required) is required",
};

export const milestonesLabels = {
  1: "Scope",
  2: "Strategy",
  3: "Walkthroughs",
  4: "Interim control testing",
  5: "Interim substantive testing",
  6: "Walkthroughs (year-end processes)",
  7: "Year-end control testing",
  8: "Year-end substantive testing",
  9: "Conclusion",
  10: "Not applicable",
  11: "Execution",
  12: "Group audit S&S",
  13: "Preliminary planning",
  14: "CRA",
  15: "Identify and assess risk",
  16: "Design response to risk",
  17: "Post-interim project management",
};

export const clientRequestStatusType = {
  1: "Draft",
  2: "Draft",
  5: "Draft",
  10: "Draft",
  11: "Draft",
  14: "Draft",
  17: "Draft",
  6: "Pending response",
  9: "Pending response",
  13: "Pending response",
  16: "Pending response",
  20: "Pending response",
  21: "Pending response",
  27: "Pending response",
  7: "Received",
  12: "Received",
  15: "Received",
  18: "Received",
  19: "Received",
  8: "Accepted",
  28: "Accepted",
};

export const filterAuditPhases = {
  1: "Scope & strategy",
  2: "Execution",
  3: "Conclusion",
};

export const taskTypeAbbreviation = {
  1: "TOC",
  2: "TOC",
  3: "TOC",
  4: "TOC",
  5: "TOC",
  6: "TOC",
  7: "RT",
  8: "RT",
  9: "RT",
  10: "RT",
  11: "RT",
  12: "OST",
  13: "OST",
  14: "PST",
  15: "OSP",
  16: "OSP",
  17: "PSP",
  18: "UDP",
  19: "UDP",
  20: "UDP",
  21: "UDP",
  22: "ACT",
  23: "GT",
  24: "GT",
  25: "GT",
  26: "OSP",
  27: "GT",
  28: "UDP",
  29: "EDC",
  30: "UDP",
  31: "UDP",
  32: "EDC",
  34: "RT",
};

export const uploadStatusLabels = {
  1: "Pending sync", //pending
  2: "Offline edited", //offlineEdit
  3: "Downloaded", //downloaded
  4: "Uploaded", //uploaded
  5: "Invalid Input", //invalidInput
  6: "Server Error", //serverError
  7: "Unexpected API Error", //unexpectedAPIError
  8: "Client Fetch Error", //clientFetchError
  9: "Post Processing Error", //postProcessingError
};

export const clientrequestRefSheetMainHeaders = {
  // reference sheet columns
  updateEyCanvas: "Update EY Canvas",
  priority: "Priority",
  assignedToGroups: "Assigned to (group)",
  assignedToUsers: "Assigned to (user)",
  eyContacts: "EY contact",
  tags: "Tags",
  timephases: "Time phases",
};

export const OstTaskReferenceSheetColumns = {
  updateEyCanvas: "Update EY Canvas",
  timePhase: "Time phase",
  taskGroup: "Task group",
  tags: "Tags",
  timephasename: "Time phase name",
  startDate: "Start date",
  endDate: "End date",
  timePhaseId: "Time phase ID",
  taskGroupName: "Task group name",
  auditPhase: "Audit phase",
  groupName: "Group name",
  taskGroupId: "Task group ID",
  tagDescription: "Description",
  tagGroup: "Tag group",
  tagLabel: "Tag",
  tagColor: "Color",
  tagId: "Tag ID",
  signOff: "Sign-off",
  signOffValue: "Sign-off value",
};

export const clientrequestInputSheetMainHeaders = {
  clientRequestTitle: "Title (required)",
  clientRequestDescription: "Description",
  AssignedToGroup: "Assigned to (group)",
  AssignedToUser: "Assigned to (user)",
  DueDate: "Due date (YYYY-MM-DD)",
  eyContact: "EY contact",
  tags: "Tags",
  priority: "Priority",
  requestGuid: "ClientRequest GUID",
  requestId: "ClientRequestID",
  statusID: "Status ID",
  timephases: "Time phase",
  requestHash: "Request #",
  requestHashSpace: "Request # ",
  clientRequestTitleSpace: "Title (required) ",
  clientRequestDescriptionSpace: "Description ",
  AssignedToGroupSpace: "Assigned to (group) ",
  AssignedToUserSpace: "Assigned to (user) ",
  DueDateSpace: "Due date (YYYY-MM-DD) ",
  eyContactSpace: "EY contact ",
  tagsSpace: "Tags ",
  prioritySpace: "Priority ",
  timephasesSpace: "Time phase ",
  requestStatusId: "Request status ID",
  requestStatus: "Request status",
};

export const clientrequestRefSheetSubHeaders = {
  priority: {
    priorityName: "Priority name",
    priorityTypeId: "Priority type ID",
  },
  assignedToGroups: {
    group: "Group",
    groupName: "Group name",
    groupId: "Group ID",
  },
  assignedToUsers: {
    groupMember: "Group member",
    name: "Name",
    groupName: "Group name",
    userId: "User ID",
    groupId: "Group ID",
  },
  eyContacts: {
    name: "Name",
    userId: "User ID",
  },
  tags: {
    tagName: "Tag",
    colorCode: "Color",
    engagementTagName: "Description",
    engagementTagID: "Tag ID",
  },
  timephases: {
    timePhaseName: "Time phase",
    periodName: "Time phase name",
    startDate: "Start date",
    dueDate: "End date",
    timephaseId: "Time phase ID",
  },
};

export const priorityTypesCollaboration = [
  {
    value: 1,
    label: "Normal",
  },
  {
    value: 3,
    label: "High",
  },
  {
    value: 4,
    label: "Critical",
  },
];

export const ButtonOptions = [
  {
    label: "Edit document names",
    activeButton: "active-btn",
    id: 1,
    DisplayOrder: 4,
  },
  {
    label: "Create draft client requests",
    activeButton: "active-btn",
    id: 3,
    DisplayOrder: 1,
  },
  {
    label: "Edit client requests",
    activeButton: "active-btn",
    id: 4,
    DisplayOrder: 2,
  },
  {
    label: "Edit ITGCs",
    activeButton: "active-btn",
    id: 5,
    DisplayOrder: 5,
  },
  {
    label: "Edit tasks",
    activeButton: "active-btn",
    id: 2,
    DisplayOrder: 8,
  },
  {
    label: "Edit time phases",
    activeButton: "active-btn",
    id: 8,
    DisplayOrder: 9,
  },
  {
    label: "Edit controls",
    activeButton: "active-btn",
    id: 6,
    DisplayOrder: 3,
  },
  {
    label: "Create tasks (OSTs)",
    activeButton: "active-btn",
    id: 7,
    DisplayOrder: 7,
  },
  {
    label: "Edit misstatements",
    activeButton: "active-btn",
    id: 9,
    DisplayOrder: 6,
  },
  {
    label: "Edit deficiencies",
    activeButton: "active-btn",
    id: 10,
    DisplayOrder: 10,
  },
];

export const ClientRequestTypeOptions = [
  {
    label: "Draft",
    id: 1,
    apiPayload: "Draft",
  },
  {
    label: "Pending response",
    id: 2,
    apiPayload: "Pending",
  },
  {
    label: "Received",
    id: 3,
    apiPayload: "Received",
  },
  {
    label: "Accepted",
    id: 4,
    apiPayload: "Accepted",
  },
];

export const colorOptionsLabels = [
  {
    value: "Red",
    label: "Red",
  },
  {
    value: "Orange",
    label: "Orange",
  },
  {
    value: "Teal",
    label: "Teal",
  },
  {
    value: "Blue",
    label: "Blue",
  },
  {
    value: "Purple",
    label: "Purple",
  },
  {
    value: "Green",
    label: "Green",
  },
  {
    value: "Yellow",
    label: "Yellow",
  },
  {
    value: "Gray",
    label: "Gray",
  },
];

export const controlFrequencyNameTypes = [
  {
    id: 1,
    value: 1,
    label: "Many times per day",
  },
  {
    id: 2,
    value: 2,
    label: "Daily",
  },
  {
    id: 3,
    value: 3,
    label: "Weekly",
  },
  {
    id: 4,
    value: 4,
    label: "Monthly",
  },
  {
    id: 5,
    value: 5,
    label: "Quarterly",
  },
  {
    id: 6,
    value: 6,
    label: "Annually",
  },
  {
    id: 8,
    value: 8,
    label: "Other",
  },
];

export const controlDesignEffectivenessType = [
  {
    id: 1,
    value: 1,
    label: "Effective",
  },
  {
    id: 2,
    value: 2,
    label: "Ineffective",
  },
];

export const operativeEffectivenessType = [
  {
    id: true,
    value: true,
    label: "Effective",
  },
  {
    id: false,
    value: false,
    label: "Ineffective",
  },
];

export const BooleanType = [
  {
    id: true,
    value: true,
    label: "true",
  },
  {
    id: false,
    value: false,
    label: "false",
  },
];

export const YesNoTypes = [
  {
    id: true,
    value: 1,
    booleanValue: true,
    label: "Yes",
  },
  {
    id: false,
    value: 0,
    booleanValue: false,
    label: "No",
  },
];

export const controlTypes = [
  {
    id: 1,
    value: 1,
    label: "IT application control",
  },
  {
    id: 2,
    value: 2,
    label: "IT dependent manual control",
  },
  {
    id: 3,
    value: 3,
    label: "Manual prevent",
  },
  {
    id: 4,
    value: 4,
    label: "Manual detect",
  },
];

// Mirrors filterMilestones in EY Canvas web: ordered the way EY Canvas displays milestones rather than by id,
// omitting Scope (1), Strategy (2) and "No milestone" (0) because EY Canvas hides those from this dropdown.
export const timephaseTypes = [
  {
    id: 12,
    value: 12,
    label: "Group audit S&S",
  },
  {
    id: 13,
    value: 13,
    label: "Preliminary planning",
  },
  {
    id: 14,
    value: 14,
    label: "CRA",
  },
  {
    id: 15,
    value: 15,
    label: "Identify and assess risk",
  },
  {
    id: 16,
    value: 16,
    label: "Design response to risk",
  },
  {
    id: 17,
    value: 17,
    label: "Post-interim project management",
  },
  {
    id: 3,
    value: 3,
    label: "Walkthroughs",
  },
  {
    id: 4,
    value: 4,
    label: "Interim control testing",
  },
  {
    id: 5,
    value: 5,
    label: "Interim substantive testing",
  },
  {
    id: 6,
    value: 6,
    label: "Walkthroughs (year-end processes)",
  },
  {
    id: 7,
    value: 7,
    label: "Year-end control testing",
  },
  {
    id: 8,
    value: 8,
    label: "Year-end substantive testing",
  },
  {
    id: 11,
    value: 11,
    label: "Execution",
  },
  {
    id: 9,
    value: 9,
    label: "Conclusion",
  },
  {
    id: 10,
    value: 10,
    label: "N/A",
  },
];

export const deficiencyCategoryTypes = [
  {
    id: 19,
    value: 19,
    label: "Business process",
  },
  {
    id: 34,
    value: 34,
    label: "IT process",
  },
];
